import React from 'react'
import PropTypes from 'prop-types'

import ReactSelect from 'react-select'
import ReactCreatableSelect from 'react-select/creatable'

import { Flex, Label, colors } from 'components/common'

const defaultStyle = {
  control: provided => ({
    ...provided,
    border: '1px solid #e6e9ed',
    borderRadius: 4,
    cursor: 'pointer',
    minHeight: 40
  }),
  menu: provided => ({
    ...provided,
    zIndex: 999999
  }),
  indicator: provided => ({
    ...provided,
    cursor: 'pointer'
  }),
  indicatorSeparator: provided => ({
    ...provided,
    display: 'none'
  })
}

const customTheme = theme => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary25: colors.primary4,
    primary50: colors.primary1,
    primary: colors.primary1
  }
})

const Select = ({
  id,
  options,
  value,
  valueFunc,
  label,
  placeholder = '-',
  isCreatable,
  wrapperProps = {},
  onChange,
  ...props
}) => {
  const SelectComponent = isCreatable ? ReactCreatableSelect : ReactSelect
  return (
    <Flex column {...wrapperProps}>
      {label && <Label id={`${id || 'select'}-label`}>{label}</Label>}
      <SelectComponent
        id={id}
        options={options}
        placeholder={placeholder}
        styles={defaultStyle}
        theme={customTheme}
        value={typeof valueFunc === 'function' ? valueFunc(value) : value}
        onChange={onChange}
        {...props}
      />
    </Flex>
  )
}

Select.DefaultStyle = defaultStyle

Select.propTypes = {
  id: PropTypes.any,
  isAsync: PropTypes.bool,
  label: PropTypes.string,
  options: PropTypes.array.isRequired,
  placeholder: PropTypes.string,
  styles: PropTypes.object,
  value: PropTypes.any,
  valueFunc: PropTypes.func,
  wrapperProps: PropTypes.object,
  isCreatable: PropTypes.bool,
  onChange: PropTypes.func
}

export default Select
